module.exports = __webpack_public_path__ + "static/media/albumicon.5403ab1b.png";